/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDiscountOrigin = {
    DEVOUR: 'DEVOUR',
    MERCHANT: 'MERCHANT',
    FUEL: 'FUEL',
    QUEST: 'QUEST',
    LOOTSHOP_CREDIT: 'LOOTSHOP_CREDIT'
} as const;
export type OrderDiscountOrigin = typeof OrderDiscountOrigin[keyof typeof OrderDiscountOrigin];


export function instanceOfOrderDiscountOrigin(value: any): boolean {
    for (const key in OrderDiscountOrigin) {
        if (Object.prototype.hasOwnProperty.call(OrderDiscountOrigin, key)) {
            if (OrderDiscountOrigin[key as keyof typeof OrderDiscountOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDiscountOriginFromJSON(json: any): OrderDiscountOrigin {
    return OrderDiscountOriginFromJSONTyped(json, false);
}

export function OrderDiscountOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountOrigin {
    return json as OrderDiscountOrigin;
}

export function OrderDiscountOriginToJSON(value?: OrderDiscountOrigin | null): any {
    return value as any;
}

export function OrderDiscountOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDiscountOrigin {
    return value as OrderDiscountOrigin;
}

